import * as THREE from 'three'
import useCamera from '~/composables/configurator/useCamera'
import useSizes from '~/composables/configurator/useSizes'
import { useAccumulativeShadows } from '~/service/experience/utils/AccumulativeShadows'
import type Resources from '~/service/experience/utils/Resources'

let canvas: HTMLElement
const sizes = useSizes()
let scene: THREE.Scene
let instance: THREE.WebGLRenderer
let shadows: ReturnType<typeof useAccumulativeShadows>
let initialized = false
let resources: Resources

export function useRenderer(
  _canvas?: HTMLCanvasElement,
  _scene?: THREE.Scene,
  _resources?: Resources
) {
  if (_scene && _canvas && _resources) {
    canvas = _canvas
    scene = _scene
    resources = _resources

    instance = new THREE.WebGLRenderer({
      canvas: canvas,
      antialias: true,
      preserveDrawingBuffer: true,
    })

    instance.shadowMap.enabled = true
    instance.outputColorSpace = THREE.SRGBColorSpace
    instance.setPixelRatio(Math.min(window.devicePixelRatio, 2))
    instance.setSize(sizes.width.value, sizes.height.value)
    instance.setPixelRatio(Math.min(window.devicePixelRatio, 2))
  }

  function resize() {
    instance.setSize(sizes.width.value, sizes.height.value)
    instance.setPixelRatio(Math.min(window.devicePixelRatio, 2))
  }

  function update() {
    if (initialized) {
      shadows.temporalUpdate()
    }
    const camera = useCamera()
    instance.render(scene, camera.instance)
  }

  function resetShadows() {
    shadows.reset()
  }

  function initProgressiveShadows() {
    const camera = useCamera()

    shadows = useAccumulativeShadows()

    shadows.setupAccumulativeShadows(
      instance,
      scene,
      camera.instance,
      resources
    )
    initialized = true
  }

  function destroy() {
    shadows = null
    instance.dispose()
  }

  return {
    destroy,
    instance,
    update,
    resize,
    initProgressiveShadows,
    resetShadows,
    scene,
  }
}
